import { DataSourceExecutionEvent } from "@mcleod/components";
import { LayoutUrl, StringUtil } from "@mcleod/core";
import { AutogenLayoutIntellirouteCityQuickInfo } from "./autogen/AutogenLayoutIntellirouteCityQuickInfo";

export class IntellirouteCityQuickInfo extends AutogenLayoutIntellirouteCityQuickInfo {

    sourceIntellirouteCityAfterExecution(event: DataSourceExecutionEvent) {
        const id = event?.data?.get("id");
        if (!StringUtil.isEmptyString(id)) {
            this.textboxId.printableLabel.link =
                LayoutUrl.create("lme/dispatch/IntellirouteCity", { mode: "update", key: id});
        }
    }

}
